import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { TotvsRepositoryToken } from '../../di/tokens';
import type { TotvsProductLinkMatchInput } from '../../domain/entities/totvs.entity';

/**
 * O de-para que **vale** para uma chave — bloco "Matrícula no TOTVS" da tela
 * da oferta (`/offers/:id`). `input` nulo (conta de gateway ainda não
 * resolvida) desliga a query em vez de consultar.
 */
export function useTotvsProductLinkMatch(
  input: TotvsProductLinkMatchInput | null,
) {
  const repository = container.resolve(TotvsRepositoryToken);
  return useQuery({
    queryKey: ['totvs', 'product-link-match', input],
    queryFn: () => repository.getProductLinkMatch(input!),
    staleTime: 1000 * 60 * 5,
    enabled: !!input,
    retry: false,
  });
}
